import _ from "lodash";
import { LOGOUT_SUCCESS } from "./AuthReducer";

export const CREATE_PLAN_REQUEST = "CREATE_PLAN_REQUEST";
export const CREATE_PLAN_SUCCESS = "CREATE_PLAN_SUCCESS";
export const CREATE_PLAN_ERROR = "CREATE_PLAN_ERROR";
export const GET_PLAN_REQUEST = "GET_PLAN_REQUEST";
export const GET_PLAN_SUCCESS = "GET_PLAN_SUCCESS";
export const GET_PLAN_ERROR = "GET_PLAN_ERROR";
export const GET_PLAN_BY_ID_REQUEST = "GET_PLAN_BY_ID_REQUEST";
export const GET_PLAN_BY_ID_SUCCESS = "GET_PLAN_BY_ID_SUCCESS";
export const GET_PLAN_BY_ID_ERROR = "GET_PLAN_BY_ID_ERROR";
export const GET_SHARED_PLAN_BY_ID_REQUEST = "GET_SHARED_PLAN_BY_ID_REQUEST";
export const GET_SHARED_PLAN_BY_ID_SUCCESS = "GET_SHARED_PLAN_BY_ID_SUCCESS";
export const GET_SHARED_PLAN_BY_ID_ERROR = "GET_SHARED_PLAN_BY_ID_ERROR";
export const UPDATE_PLAN_REQUEST = "UPDATE_PLAN_REQUEST";
export const UPDATE_PLAN_SUCCESS = "UPDATE_PLAN_SUCCESS";
export const UPDATE_PLAN_ERROR = "UPDATE_PLAN_ERROR";
export const REMOVE_PLAN_REQUEST = "REMOVE_PLAN_REQUEST";
export const REMOVE_PLAN_SUCCESS = "REMOVE_PLAN_SUCCESS";
export const REMOVE_PLAN_ERROR = "REMOVE_PLAN_ERROR";
export const ARCHIVE_PLAN_REQUEST = "ARCHIVE_PLAN_REQUEST";
export const ARCHIVE_PLAN_SUCCESS = "ARCHIVE_PLAN_SUCCESS";
export const ARCHIVE_PLAN_ERROR = "ARCHIVE_PLAN_ERROR";
export const CREATE_ACTION_ITEM_REQUEST = "CREATE_ACTION_ITEM_REQUEST";
export const CREATE_ACTION_ITEM_SUCCESS = "CREATE_ACTION_ITEM_SUCCESS";
export const CREATE_ACTION_ITEM_ERROR = "CREATE_ACTION_ITEM_ERROR";
export const UPDATE_ACTION_ITEM_REQUEST = "UPDATE_ACTION_ITEM_REQUEST";
export const UPDATE_ACTION_ITEM_SUCCESS = "UPDATE_ACTION_ITEM_SUCCESS";
export const UPDATE_ACTION_ITEM_ERROR = "UPDATE_ACTION_ITEM_ERROR";
export const DELETE_ACTION_ITEM_REQUEST = "DELETE_ACTION_ITEM_REQUEST";
export const DELETE_ACTION_ITEM_SUCCESS = "DELETE_ACTION_ITEM_SUCCESS";
export const DELETE_ACTION_ITEM_ERROR = "DELETE_ACTION_ITEM_ERROR";
export const CHANGE_ACTION_ITEM_ORDERS_REQUEST =
  "CHANGE_ACTION_ITEM_ORDERS_REQUEST";
export const CHANGE_ACTION_ITEM_ORDERS_SUCCESS =
  "CHANGE_ACTION_ITEM_ORDERS_SUCCESS";
export const CHANGE_ACTION_ITEM_ORDERS_ERROR =
  "CHANGE_ACTION_ITEM_ORDERS_ERROR";
export const CHANGE_PLAN_CATEGORY_ORDERS_REQUEST =
  "CHANGE_PLAN_CATEGORY_ORDERS_REQUEST";
export const CHANGE_PLAN_CATEGORY_ORDERS_SUCCESS =
  "CHANGE_PLAN_CATEGORY_ORDERS_SUCCESS";
export const CHANGE_PLAN_CATEGORY_ORDERS_ERROR =
  "CHANGE_PLAN_CATEGORY_ORDERS_ERROR";
export const CHANGE_CATEGORY_ORDERS_REQUEST = "CHANGE_CATEGORY_ORDERS_REQUEST";
export const CHANGE_CATEGORY_ORDERS_SUCCESS = "CHANGE_CATEGORY_ORDERS_SUCCESS";
export const CHANGE_CATEGORY_ORDERS_ERROR = "CHANGE_CATEGORY_ORDERS_ERROR";
export const CREATE_PLAN_CATEGORY_REQUEST = "CREATE_PLAN_CATEGORY_REQUEST";
export const CREATE_PLAN_CATEGORY_SUCCESS = "CREATE_PLAN_CATEGORY_SUCCESS";
export const CREATE_PLAN_CATEGORY_ERROR = "CREATE_PLAN_CATEGORY_ERROR";
export const UPDATE_PLAN_CATEGORY_REQUEST = "UPDATE_PLAN_CATEGORY_REQUEST";
export const UPDATE_PLAN_CATEGORY_SUCCESS = "UPDATE_PLAN_CATEGORY_SUCCESS";
export const UPDATE_PLAN_CATEGORY_ERROR = "UPDATE_PLAN_CATEGORY_ERROR";
export const ADJUST_CATEGORY_WEIGHT_REQUEST = "ADJUST_CATEGORY_WEIGHT_REQUEST";
export const ADJUST_CATEGORY_WEIGHT_SUCCESS = "ADJUST_CATEGORY_WEIGHT_SUCCESS";
export const ADJUST_CATEGORY_WEIGHT_ERROR = "ADJUST_CATEGORY_WEIGHT_ERROR";
export const DELETE_PLAN_CATEGORY_REQUEST = "DELETE_PLAN_CATEGORY_REQUEST";
export const DELETE_PLAN_CATEGORY_SUCCESS = "DELETE_PLAN_CATEGORY_SUCCESS";
export const DELETE_PLAN_CATEGORY_ERROR = "DELETE_PLAN_CATEGORY_ERROR";
export const CREATE_NOTES_REQUEST = "CREATE_NOTES_REQUEST";
export const CREATE_NOTES_SUCCESS = "CREATE_NOTES_SUCCESS";
export const CREATE_NOTES_ERROR = "CREATE_NOTES_ERROR";
export const UPDATE_NOTES_REQUEST = "UPDATE_NOTES_REQUEST";
export const UPDATE_NOTES_SUCCESS = "UPDATE_NOTES_SUCCESS";
export const UPDATE_NOTES_ERROR = "UPDATE_NOTES_ERROR";
export const DELETE_NOTES_REQUEST = "DELETE_NOTES_REQUEST";
export const DELETE_NOTES_SUCCESS = "DELETE_NOTES_SUCCESS";
export const DELETE_NOTES_ERROR = "DELETE_NOTES_ERROR";
export const GET_TOOL_REQUEST = "GET_TOOL_REQUEST";
export const GET_TOOL_SUCCESS = "GET_TOOL_SUCCESS";
export const GET_TOOL_ERROR = "GET_TOOL_ERROR";
export const GET_ALL_USER_REQUEST = "GET_ALL_USER_REQUEST";
export const GET_ALL_USER_SUCCESS = "GET_ALL_USER_SUCCESS";
export const GET_ALL_USER_ERROR = "GET_ALL_USER_ERROR";
export const UPDATE_COLLABORATOR_REQUEST = "UPDATE_COLLABORATOR_REQUEST";
export const UPDATE_COLLABORATOR_SUCCESS = "UPDATE_COLLABORATOR_SUCCESS";
export const UPDATE_COLLABORATOR_ERROR = "UPDATE_COLLABORATOR_ERROR";
export const CREATE_REQUEST_ACCESS_REQUEST = "CREATE_REQUEST_ACCESS_REQUEST";
export const CREATE_REQUEST_ACCESS_SUCCESS = "CREATE_REQUEST_ACCESS_SUCCESS";
export const CREATE_REQUEST_ACCESS_ERROR = "CREATE_REQUEST_ACCESS_ERROR";
export const CREATE_TOOL_REQUEST = "CREATE_TOOL_REQUEST";
export const CREATE_TOOL_SUCCESS = "CREATE_TOOL_SUCCESS";
export const CREATE_TOOL_ERROR = "CREATE_TOOL_ERROR";
export const BULK_UPDATE_TOOL_REQUEST = "BULK_UPDATE_TOOL_REQUEST";
export const BULK_UPDATE_TOOL_SUCCESS = "BULK_UPDATE_TOOL_SUCCESS";
export const BULK_UPDATE_TOOL_ERROR = "BULK_UPDATE_TOOL_ERROR";
export const UPDATE_TOOL_REQUEST = "UPDATE_TOOL_REQUEST";
export const UPDATE_TOOL_SUCCESS = "UPDATE_TOOL_SUCCESS";
export const UPDATE_TOOL_ERROR = "UPDATE_TOOL_ERROR";
export const DELETE_TOOL_REQUEST = "DELETE_TOOL_REQUEST";
export const DELETE_TOOL_SUCCESS = "DELETE_TOOL_SUCCESS";
export const DELETE_TOOL_ERROR = "DELETE_TOOL_ERROR";
export const CREATE_R_FILE_REQUEST = "CREATE_R_FILE_REQUEST";
export const CREATE_R_FILE_SUCCESS = "CREATE_R_FILE_SUCCESS";
export const CREATE_R_FILE_ERROR = "CREATE_R_FILE_ERROR";
export const UPDATE_R_FILE_REQUEST = "UPDATE_R_FILE_REQUEST";
export const UPDATE_R_FILE_SUCCESS = "UPDATE_R_FILE_SUCCESS";
export const UPDATE_R_FILE_ERROR = "UPDATE_R_FILE_ERROR";
export const DELETE_R_FILE_REQUEST = "DELETE_R_FILE_REQUEST";
export const DELETE_R_FILE_SUCCESS = "DELETE_R_FILE_SUCCESS";
export const DELETE_R_FILE_ERROR = "DELETE_R_FILE_ERROR";
export const UPDATE_RESOURCES_REQUEST = "UPDATE_RESOURCES_REQUEST";
export const UPDATE_RESOURCES_SUCCESS = "UPDATE_RESOURCES_SUCCESS";
export const UPDATE_RESOURCES_ERROR = "UPDATE_RESOURCES_ERROR";
export const UPDATE_GOAL_REQUEST = "UPDATE_GOAL_REQUEST";
export const UPDATE_GOAL_SUCCESS = "UPDATE_GOAL_SUCCESS";
export const UPDATE_GOAL_ERROR = "UPDATE_GOAL_ERROR";
export const BULK_GOAL_UPDATE_REQUEST = "BULK_GOAL_UPDATE_REQUEST";
export const BULK_GOAL_UPDATE_SUCCESS = "BULK_GOAL_UPDATE_SUCCESS";
export const BULK_GOAL_UPDATE_ERROR = "BULK_GOAL_UPDATE_ERROR";

export const UPADTE_GOAL_LABEL_REQUEST = "UPADTE_GOAL_LABEL_REQUEST";
export const UPADTE_GOAL_LABEL_SUCCESS = "UPADTE_GOAL_LABEL_SUCCESS";
export const UPADTE_GOAL_LABEL_ERROR = "UPADTE_GOAL_LABEL_ERROR";

export const DELETE_GOAL_REQUEST = "DELETE_GOAL_REQUEST";
export const DELETE_GOAL_SUCCESS = "DELETE_GOAL_SUCCESS";
export const DELETE_GOAL_ERROR = "DELETE_GOAL_ERROR";
export const CREATE_REMINDER_REQUEST = "CREATE_REMINDER_REQUEST";
export const CREATE_REMINDER_SUCCESS = "CREATE_REMINDER_SUCCESS";
export const CREATE_REMINDER_ERROR = "CREATE_REMINDER_ERROR";
export const CREATE_LABEL_AND_UNITS_REQUEST = "CREATE_LABEL_AND_UNITS_REQUEST";
export const CREATE_LABEL_AND_UNITS_SUCCESS = "CREATE_LABEL_AND_UNITS_SUCCESS";
export const CREATE_LABEL_AND_UNITS_ERROR = "CREATE_LABEL_AND_UNITS_ERROR";

export const CLONE_PLAN_REQUEST = "CLONE_PLAN_REQUEST";
export const CLONE_PLAN_SUCCESS = "CLONE_PLAN_SUCCESS";
export const CLONE_PLAN_ERROR = "CLONE_PLAN_ERROR";

export const GET_PROJECT_PREFERENCES_REQUEST =
  "GET_PROJECT_PREFERENCES_REQUEST";
export const GET_PROJECT_PREFERENCES_SUCCESS =
  "GET_PROJECT_PREFERENCES_SUCCESS";
export const GET_PROJECT_PREFERENCES_ERROR = "GET_PROJECT_PREFERENCES_ERROR";

export const CREATE_PROJECT_PREFERENCES_REQUEST =
  "CREATE_PROJECT_PREFERENCES_REQUEST";
export const CREATE_PROJECT_PREFERENCES_SUCCESS =
  "CREATE_PROJECT_PREFERENCES_SUCCESS";
export const CREATE_PROJECT_PREFERENCES_ERROR =
  "CREATE_PROJECT_PREFERENCES_ERROR";

export const UPDATE_PROJECT_PREFERENCES_REQUEST =
  "UPDATE_PROJECT_PREFERENCES_REQUEST";
export const UPDATE_PROJECT_PREFERENCES_SUCCESS =
  "UPDATE_PROJECT_PREFERENCES_SUCCESS";
export const UPDATE_PROJECT_PREFERENCES_ERROR =
  "UPDATE_PROJECT_PREFERENCES_ERROR";

export const UPDATE_PROJECT_MANUAL_STATUS_REQUEST =
  "UPDATE_PROJECT_MANUAL_STATUS_REQUEST";
export const UPDATE_PROJECT_MANUAL_STATUS_SUCCESS =
  "UPDATE_PROJECT_MANUAL_STATUS_SUCCESS";
export const UPDATE_PROJECT_MANUAL_STATUS_ERROR =
  "UPDATE_PROJECT_MANUAL_STATUS_ERROR";

export const GET_GOAL_LIST_REQUEST = "GET_GOAL_LIST_REQUEST";
export const GET_GOAL_LIST_SUCCESS = "GET_GOAL_LIST_SUCCESS";
export const GET_GOAL_LIST_ERROR = "GET_GOAL_LIST_ERROR";

export const GET_GOAL_LIST_BY_ID_REQUEST = "GET_GOAL_LIST_BY_ID_REQUEST";
export const GET_GOAL_LIST_BY_ID_SUCCESS = "GET_GOAL_LIST_BY_ID_SUCCESS";
export const GET_GOAL_LIST_BY_ID_ERROR = "GET_GOAL_LIST_BY_ID_ERROR";

export const UPDATE_CUSTOMIZE_COLUMN_REQUEST = "UPDATE_CUSTOMIZE_PLAN_REQUEST";
export const UPDATE_CUSTOMIZE_COLUMN_SUCCESS = "UPDATE_CUSTOMIZE_PLAN_SUCCESS";
export const UPDATE_CUSTOMIZE_COLUMN_ERROR = "UPDATE_CUSTOMIZE_PLAN_ERROR";

export const UPDATE_CUSTOMIZE_COLUMN_FROZEN_REQUEST =
  "UPDATE_CUSTOMIZE_COLUMN_FROZEN_REQUEST";
export const UPDATE_CUSTOMIZE_COLUMN_FROZEN_SUCCESS =
  "UPDATE_CUSTOMIZE_COLUMN_FROZEN_SUCCESS";
export const UPDATE_CUSTOMIZE_COLUMN_FROZEN_ERROR =
  "UPDATE_CUSTOMIZE_COLUMN_FROZEN_ERROR";

export const GET_CUSTOMIZE_COLUMN_REQUEST = "GET_CUSTOMIZE_COLUMN_REQUEST";
export const GET_CUSTOMIZE_COLUMN_SUCCESS = "GET_CUSTOMIZE_COLUMN_SUCCESS";
export const GET_CUSTOMIZE_COLUMN_ERROR = "GET_CUSTOMIZE_COLUMN_ERROR";

export const GET_CUSTOMIZE_COLUMN_FROZEN_REQUEST =
  "GET_CUSTOMIZE_COLUMN_FROZEN_REQUEST";
export const GET_CUSTOMIZE_COLUMN_FROZEN_SUCCESS =
  "GET_CUSTOMIZE_COLUMN_FROZEN_SUCCESS";
export const GET_CUSTOMIZE_COLUMN_FROZEN_ERROR =
  "GET_CUSTOMIZE_COLUMN_FROZEN_ERROR";

export const CREATE_NEW_ACTION_ITEM_REQUEST = "CREATE_NEW_ACTION_ITEM_REQUEST";
export const CREATE_NEW_ACTION_ITEM_SUCCESS = "CREATE_NEW_ACTION_ITEM_SUCCESS";
export const CREATE_NEW_ACTION_ITEM_ERROR = "CREATE_NEW_ACTION_ITEM_ERROR";

export const CLEAR_SELECTED_GOAL_LIST = "CLEAR_SELECTED_GOAL_LIST";
export const CLEAR_UPLOAD_FILE = "CLEAR_UPLOAD_FILE";

export const UPLOAD_FILE_WITHOUT_PROJECTID_REQUEST =
  "UPLOAD_FILE_WITHOUT_PROJECTID_REQUEST";
export const UPLOAD_FILE_WITHOUT_PROJECTID_SUCCESS =
  "UPLOAD_FILE_WITHOUT_PROJECTID_SUCCESS";
export const UPLOAD_FILE_WITHOUT_PROJECTID_ERROR =
  "UPLOAD_FILE_WITHOUT_PROJECTID_ERROR";

export const CREATE_PROJECT_PLAN_REQUEST = "CREATE_PROJECT_PLAN_REQUEST";
export const CREATE_PROJECT_PLAN_SUCCESS = "CREATE_PROJECT_PLAN_SUCCESS";
export const CREATE_PROJECT_PLAN_ERROR = "CREATE_PROJECT_PLAN_ERROR";

export const POST_METRIC_REQUEST = "POST_METRIC_REQUEST";
export const POST_METRIC_SUCCESS = "POST_METRIC_SUCCESS";
export const POST_METRIC_ERROR = "POST_METRIC_ERROR";
export const BULK_UPDATE_PLAN_ACTION_CATEGORY_REQUEST =
  "BULK_UPDATE_PLAN_ACTION_CATEGORY_REQUEST";
export const BULK_UPDATE_PLAN_ACTION_CATEGORY_SUCCESS =
  "BULK_UPDATE_PLAN_ACTION_CATEGORY_SUCCESS";
export const BULK_UPDATE_PLAN_ACTION_CATEGORY_ERROR =
  "BULK_UPDATE_PLAN_ACTION_CATEGORY_ERROR";

export const UPDATE_USER_TUTORIAL_REQUEST = "UPDATE_USER_TUTORIAL_REQUEST";
export const UPDATE_USER_TUTORIAL_SUCCESS = "UPDATE_USER_TUTORIAL_SUCCESS";
export const UPDATE_USER_TUTORIAL_ERROR = "UPDATE_USER_TUTORIAL_ERROR";
export const WEIGHT_MODEL = "WEIGHT_MODEL";
export const WIZARD_DATA = "WIZARD_DATA";
export const UPDATE_SORT_CATEGORY = "UPDATE_SORT_CATEGORY";

export const UPDATE_CATEGORY_NAME_REQUEST = "UPDATE_CATEGORY_NAME_REQUEST";
export const UPDATE_CATEGORY_NAME_SUCCESS = "UPDATE_CATEGORY_NAME_SUCCESS";
export const UPDATE_CATEGORY_NAME_ERROR = "UPDATE_CATEGORY_NAME_ERROR";

export const ADD_BULK_CATEGORY_REQUEST = "ADD_BULK_CATEGORY_REQUEST";
export const ADD_BULK_CATEGORY_SUCCESS = "ADD_BULK_CATEGORY_SUCCESS";
export const ADD_BULK_CATEGORY_ERROR = "ADD_BULK_CATEGORY_ERROR";

export const UPDATE_BULK_ACTION_REQUEST = "UPDATE_BULK_ACTION_REQUEST";
export const UPDATE_BULK_ACTION_SUCCESS = "UPDATE_BULK_ACTION_SUCCESS";
export const UPDATE_BULK_ACTION_ERROR = "UPDATE_BULK_ACTION_ERROR";

export const GET_PREDEFINED_METRICS_REQUEST = "GET_PREDEFINED_METRICS_REQUEST";
export const GET_PREDEFINED_METRICS_SUCCESS = "GET_PREDEFINED_METRICS_SUCCESS";
export const GET_PREDEFINED_METRICS_ERROR = "GET_PREDEFINED_METRICS_ERROR";

export const NOTIFICATION_SETTING_REQUEST = "NOTIFICATION_SETTING_REQUEST";
export const NOTIFICATION_SETTING_SUCCESS = "NOTIFICATION_SETTING_SUCCESS";
export const NOTIFICATION_SETTING_ERROR = "NOTIFICATION_SETTING_ERROR";

export const GET_NOTIFICATION_SETTING_REQUEST =
  "GET_NOTIFICATION_SETTING_REQUEST";
export const GET_NOTIFICATION_SETTING_SUCCESS =
  "GET_NOTIFICATION_SETTING_SUCCESS";
export const GET_NOTIFICATION_SETTING_ERROR = "GET_NOTIFICATION_SETTING_ERROR";

export const SORT_DATA = "SORT_DATA";

export const CREATE_PROJECT_WITH_WIZARD_REQUEST =
  "CREATE_PROJECT_WITH_WIZARD_REQUEST";
export const CREATE_PROJECT_WITH_WIZARD_SUCCESS =
  "CREATE_PROJECT_WITH_WIZARD_SUCCESS";
export const CREATE_PROJECT_WITH_WIZARD_ERROR =
  "CREATE_PROJECT_WITH_WIZARD_ERROR";

export const BULK_ARIA_PROJECT_PLAN_REQUEST = "BULK_ARIA_PROJECT_PLAN_REQUEST";
export const BULK_ARIA_PROJECT_PLAN_SUCCESS = "BULK_ARIA_PROJECT_PLAN_SUCCESS";
export const BULK_ARIA_PROJECT_PLAN_ERROR = "BULK_ARIA_PROJECT_PLAN_ERROR";

export const UPLOAD_CSV_REQUEST = "UPLOAD_CSV_REQUEST";
export const UPLOAD_CSV_SUCCESS = "UPLOAD_CSV_SUCCESS";
export const UPLOAD_CSV_ERROR = "UPLOAD_CSV_ERROR";

export const GET_ACTIVITY_LOG_REQUEST = "GET_ACTIVITY_LOG_REQUEST";
export const GET_ACTIVITY_LOG_SUCCESS = "GET_ACTIVITY_LOG_SUCCESS";
export const GET_ACTIVITY_LOG_ERROR = "GET_ACTIVITY_LOG_ERROR";

export const GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_REQUEST =
  "GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_REQUEST";
export const GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_SUCCESS =
  "GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_SUCCESS";
export const GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_ERROR =
  "GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_ERROR";

export const CREATE_ACTION_ITEM_COMMENT_REQUEST =
  "CREATE_ACTION_ITEM_COMMENT_REQUEST";
export const CREATE_ACTION_ITEM_COMMENT_SUCCESS =
  "CREATE_ACTION_ITEM_COMMENT_SUCCESS";
export const CREATE_ACTION_ITEM_COMMENT_ERROR =
  "CREATE_ACTION_ITEM_COMMENT_ERROR";

export const UPDATE_COMMENT_REQUEST = "UPDATE_COMMENT_REQUEST";
export const UPDATE_COMMENT_SUCCESS = "UPDATE_COMMENT_SUCCESS";
export const UPDATE_COMMENT_ERROR = "UPDATE_COMMENT_ERROR";

export const LIKE_COMMENT_REQUEST = "LIKE_COMMENT_REQUEST";
export const LIKE_COMMENT_SUCCESS = "LIKE_COMMENT_SUCCESS";
export const LIKE_COMMENT_ERROR = "LIKE_COMMENT_ERROR";

export const UNLIKE_COMMENT_REQUEST = "UNLIKE_COMMENT_REQUEST";
export const UNLIKE_COMMENT_SUCCESS = "UNLIKE_COMMENT_SUCCESS";
export const UNLIKE_COMMENT_ERROR = "UNLIKE_COMMENT_ERROR";

export const DELETE_COMMENT_REQUEST = "DELETE_COMMENT_REQUEST";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_ERROR = "DELETE_COMMENT_ERROR";

export const REPLY_COMMENT_REQUEST = "REPLY_COMMENT_REQUEST";
export const REPLY_COMMENT_SUCCESS = "REPLY_COMMENT_SUCCESS";
export const REPLY_COMMENT_ERROR = "REPLY_COMMENT_ERROR";

export const UPDATE_CATEGORY_STATE_REQUEST = "UPDATE_CATEGORY_STATE_REQUEST";
export const UPDATE_CATEGORY_STATE_SUCCESS = "UPDATE_CATEGORY_STATE_SUCCESS";
export const UPDATE_CATEGORY_STATE_ERROR = "UPDATE_CATEGORY_STATE_ERROR";

export const IS_CATEGORY_STATE_UNACTIVE = "IS_CATEGORY_STATE_UNACTIVE";

export const DUPLICATE_PLAN_REQUEST = "DUPLICATE_PLAN_REQUEST";
export const DUPLICATE_PLAN_SUCCESS = "DUPLICATE_PLAN_SUCCESS";
export const DUPLICATE_PLAN_ERROR = "DUPLICATE_PLAN_ERROR";

export const UPDATE_VIEW_TYPE_REQUEST = "UPDATE_VIEW_TYPE_REQUEST";
export const UPDATE_VIEW_TYPE_SUCCESS = "UPDATE_VIEW_TYPE_SUCCESS";
export const UPDATE_VIEW_TYPE_ERROR = "UPDATE_VIEW_TYPE_ERROR";

export const VIEW_TYPE_LIST = "VIEW_TYPE_LIST";
export const SET_CUSTOMIZE_COLUMNS_STATE = "SET_CUSTOMIZE_COLUMNS_STATE";

const block = {
  loading: false,
  error: "",
  success: false,
};

const initialState = {
  plan: {
    ...block,
    allPlans: [],
    tools: [],
    allRequest: [],
    newtool: {},
    newCategory: {},
    planPreferences: null,
    allGoalList: [],
    selectedGoalList: null,
    uploadFile: null,
    updateStatusLoading: false,
    loadingUplaod: false,
    weightModel: false,
    loadingDelete: false,
    loadingPlan: false,
    loadingArchive: false,
    loadingUpdatePlan: false,
    loadingNote: false,
    loadingNoteUpdate: false,
    loadingAdjustCategoryWeight: false,
    planDetails: null,
    loadingUpdatePerferences: false,
    loadingUpdateBulkTodo: false,
    sortData: null,
    itemUpdateNameLoading: false,
    updateCategoryNameLoading: false,
    wizardData: null,
    LoadingGoals: false,
    predefinedMetrics: {},
    notificationData: {},
    uploadCSVData: null,
    activityLoading: false,
    commentOfSpecificActionItemLoading: false,
    activityLog: [],
    commentOfSpecificActionItem: [],
    isUnActiveCategories: [],
    customizeColumn: null,
    customizeColumnFrozen: null,
    customizeColumnState: null,
    loadingCustomizeColumn: false,
    loadingCustomizeColumnFrozen: false,
    viewTypeList: [],
  },
};

export const PlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PLAN_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CREATE_PLAN_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          allPlans: [action.payload, ...state.plan.allPlans],
          loading: false,
          success: true,
        },
      };
    case CREATE_PLAN_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };

    case GET_PLAN_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case GET_PLAN_SUCCESS: {
      const newPlans = _.get(action, "payload.response", []);
      const searchQuery = _.get(action, "payload.search", "").toLowerCase();

      let existingPlans = state.plan.allPlans || [];
      let updatedPlans = searchQuery
        ? newPlans.filter((plan) =>
            plan.name.toLowerCase().includes(searchQuery)
          )
        : [
            ...newPlans
              .reduce((acc, newPlan) => {
                acc.set(newPlan.id, newPlan);
                return acc;
              }, new Map(existingPlans.map((plan) => [plan.id, plan])))
              .values(),
          ];

      return {
        ...state,
        plan: {
          ...state.plan,
          allPlans: updatedPlans,
          loading: false,
          success: true,
        },
      };
    }
    case GET_PLAN_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case GET_PLAN_BY_ID_REQUEST:
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingPlan: true,
        },
      };
    case GET_PLAN_BY_ID_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          planDetails: action.payload,
          loading: false,
          success: true,
          loadingPlan: false,
          loadingNote: false,
          loadingNoteUpdate: false,
          loadingAdjustCategoryWeight: false,
          updateActionitemLoading: false,
        },
      };
    case GET_PLAN_BY_ID_ERROR:
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingPlan: false,
          loading: false,
          error: action.error,
        },
      };
    case GET_SHARED_PLAN_BY_ID_REQUEST:
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingPlan: true,
        },
      };
    case GET_SHARED_PLAN_BY_ID_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          planDetails: action.payload,
          loading: false,
          success: true,
          loadingPlan: false,
        },
      };
    case GET_SHARED_PLAN_BY_ID_ERROR:
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingPlan: false,
          loading: false,
          error: action.error,
        },
      };
    case REMOVE_PLAN_REQUEST:
      return { ...state, plan: { ...state.plan, loadingDelete: true } };
    case REMOVE_PLAN_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          allPlans: state.plan.allPlans.filter(
            (plan) => plan.id !== action.payload
          ),
          planDetails: null,
          loadingDelete: false,
          success: true,
        },
      };
    case REMOVE_PLAN_ERROR:
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingUpdatePlan: false,
          loadingDelete: false,
          error: action.error,
        },
      };
    case ARCHIVE_PLAN_REQUEST:
      return { ...state, plan: { ...state.plan, loadingArchive: true } };
    case ARCHIVE_PLAN_SUCCESS: {
      const updatedPlans = state.plan.allPlans.map((plan) =>
        plan.id === action.payload.project_plan
          ? { ...plan, is_archived: action.payload.is_archived }
          : plan
      );

      return {
        ...state,
        plan: {
          ...state.plan,
          allPlans: [...updatedPlans],
          planDetails: null,
          loadingArchive: false,
          success: true,
        },
      };
    }
    case ARCHIVE_PLAN_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loadingArchive: false, error: action.error },
      };
    case UPDATE_PLAN_REQUEST:
      return { ...state, plan: { ...state.plan, loadingUpdatePlan: true } };
    case UPDATE_PLAN_SUCCESS: {
      const updatedPlans = state.plan.allPlans.map((plan) =>
        plan.id === action.payload.id ? { ...plan, ...action.payload } : plan
      );

      return {
        ...state,
        plan: {
          ...state.plan,
          allPlans: updatedPlans,
          loadingUpdatePlan: false,
          success: true,
        },
      };
    }
    case UPDATE_PLAN_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loadingUpdatePlan: false, error: action.error },
      };
    case CREATE_ACTION_ITEM_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CREATE_ACTION_ITEM_SUCCESS:
      return {
        ...state,
      };
    case CREATE_ACTION_ITEM_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };

    case CREATE_NEW_ACTION_ITEM_REQUEST:
      return {
        ...state,
        plan: { ...state.plan, updateActionitemLoading: true },
      };
    case CREATE_NEW_ACTION_ITEM_SUCCESS:
      return {
        ...state,
        plan: { ...state.plan, updateActionitemLoading: false },
      };
    case CREATE_NEW_ACTION_ITEM_ERROR:
      return {
        ...state,
        plan: {
          ...state.plan,
          updateActionitemLoading: false,
          error: action.error,
        },
      };
    case UPDATE_ACTION_ITEM_REQUEST: {
      // Map through categories to find the right one
      const processedCategories = state.plan.planDetails.categories.map(
        (category) => {
          return {
            ...category,
            // Map through action items to find and update the correct one
            action_items: category.action_items.map((item) => {
              // Check if this item is the one that needs updating
              if (item.id === action.id) {
                // Found the item, now update it with payload data using the spread operator
                return {
                  ...item,
                  ...action.payload, // Assuming action.payload.data contains the updated data for the item
                };
              }
              // If not the item, return it unchanged
              return item;
            }),
          };
        }
      );

      return {
        ...state,
        plan: {
          ...state.plan,
          planDetails: {
            ...state.plan.planDetails,
            categories: processedCategories,
          },
          loading: true, // This might not need to be set here depending on your loading logic
        },
      };
    }
    case UPDATE_ACTION_ITEM_SUCCESS:
      return {
        ...state,
        // plan: { ...state.plan, loading: false },
      };
    case UPDATE_ACTION_ITEM_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case DELETE_ACTION_ITEM_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case DELETE_ACTION_ITEM_SUCCESS:
      return {
        ...state,
      };
    case DELETE_ACTION_ITEM_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };

    case CHANGE_ACTION_ITEM_ORDERS_REQUEST: {
      const processedCategories = state.plan.planDetails.categories.map(
        (category) => {
          if (category.id === action.payload.category) {
            return {
              ...category,
              action_items: category.action_items
                .map((item) => {
                  const itemOriginal = action.payload.actions.find(
                    (action) => action.id === item.id
                  );

                  if (itemOriginal) {
                    return {
                      ...item,
                      order_id: itemOriginal.order_id,
                    };
                  }

                  return item;
                })
                .sort((a, b) => a.order_id - b.order_id),
            };
          }

          return category;
        }
      );

      return {
        ...state,
        plan: {
          ...state.plan,
          planDetails: {
            ...state.plan.planDetails,
            categories: processedCategories,
          },
          loading: true,
        },
      };
    }
    case CHANGE_ACTION_ITEM_ORDERS_SUCCESS:
      return {
        ...state,
      };

    case CHANGE_ACTION_ITEM_ORDERS_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case CHANGE_PLAN_CATEGORY_ORDERS_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CHANGE_PLAN_CATEGORY_ORDERS_SUCCESS:
      return {
        ...state,
      };
    case CHANGE_PLAN_CATEGORY_ORDERS_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case CHANGE_CATEGORY_ORDERS_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CHANGE_CATEGORY_ORDERS_SUCCESS:
      return {
        ...state,
      };
    case CHANGE_CATEGORY_ORDERS_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case CREATE_PLAN_CATEGORY_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CREATE_PLAN_CATEGORY_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          newCategory: action.newData,
        },
      };
    case CREATE_PLAN_CATEGORY_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case UPDATE_PLAN_CATEGORY_REQUEST: {
      // Map through categories to find the right one
      const processedCategories = state.plan.planDetails.categories.map(
        (category) => {
          const payload = action.payload;

          if (payload.start && payload.start !== null) {
            payload.start = Number(action.payload.start).toFixed(2);
          }
          if (payload.current && payload.current !== null) {
            payload.current = Number(action.payload.current).toFixed(2);
          }
          if (payload.target && payload.target !== null) {
            payload.target = Number(action.payload.target).toFixed(2);
          }

          if (category.id === action.id) {
            return {
              ...category,
              ...payload,
            };
          }

          return category;
        }
      );

      return {
        ...state,
        plan: {
          ...state.plan,
          planDetails: {
            ...state.plan.planDetails,
            categories: processedCategories,
          },
          loading: true, // This might not need to be set here depending on your loading logic
        },
      };
    }
    case UPDATE_PLAN_CATEGORY_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_PLAN_CATEGORY_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case ADJUST_CATEGORY_WEIGHT_REQUEST:
      return {
        ...state,
        plan: { ...state.plan, loadingAdjustCategoryWeight: true },
      };
    case ADJUST_CATEGORY_WEIGHT_SUCCESS:
      return {
        loadingAdjustCategoryWeight: false,
        ...state,
      };
    case ADJUST_CATEGORY_WEIGHT_ERROR:
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingAdjustCategoryWeight: false,
          error: action.error,
        },
      };
    case DELETE_PLAN_CATEGORY_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case DELETE_PLAN_CATEGORY_SUCCESS:
      return {
        ...state,
      };
    case DELETE_PLAN_CATEGORY_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case CREATE_NOTES_REQUEST:
      return { ...state, plan: { ...state.plan, loadingNote: true } };
    case CREATE_NOTES_SUCCESS:
      return {
        ...state,
        loadingNote: false,
      };
    case CREATE_NOTES_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loadingNote: false, error: action.error },
      };
    case UPDATE_NOTES_REQUEST:
      return { ...state, plan: { ...state.plan, loadingNoteUpdate: true } };
    case UPDATE_NOTES_SUCCESS:
      return {
        ...state,
        loadingNoteUpdate: false,
      };
    case UPDATE_NOTES_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loadingNoteUpdate: false, error: action.error },
      };
    case DELETE_NOTES_REQUEST:
      return { ...state, plan: { ...state.plan, loadingNoteUpdate: true } };
    case DELETE_NOTES_SUCCESS:
      return {
        ...state,
        loadingNoteUpdate: false,
      };
    case DELETE_NOTES_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loadingNoteUpdate: false, error: action.error },
      };
    case CREATE_TOOL_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CREATE_TOOL_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          newtool: action.payload,
          loading: false,
          success: true,
        },
      };
    case CREATE_TOOL_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case BULK_UPDATE_TOOL_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case BULK_UPDATE_TOOL_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          newtool: action.payload,
          loading: false,
          success: true,
        },
      };
    case BULK_UPDATE_TOOL_ERROR:
      return {
        ...state,
        plan: {
          ...state.plan,
          loading: false,
          error: action.error,
        },
      };

    case GET_TOOL_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case GET_TOOL_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          tools: action.payload,
          loading: false,
          success: true,
        },
      };
    case GET_TOOL_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case UPDATE_TOOL_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case UPDATE_TOOL_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_TOOL_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case DELETE_TOOL_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case DELETE_TOOL_SUCCESS:
      return {
        ...state,
      };
    case DELETE_TOOL_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };

    case GET_ALL_USER_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case GET_ALL_USER_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          allRequest: action.payload,
          loading: false,
          success: true,
        },
      };
    case GET_ALL_USER_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };

    case UPDATE_COLLABORATOR_REQUEST:
      return { ...state, plan: { ...state.plan } };
    case UPDATE_COLLABORATOR_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_COLLABORATOR_ERROR:
      return {
        ...state,
        plan: { ...state.plan, error: action.error },
      };
    case CREATE_REQUEST_ACCESS_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CREATE_REQUEST_ACCESS_SUCCESS:
      return {
        ...state,
      };
    case CREATE_REQUEST_ACCESS_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case CREATE_R_FILE_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CREATE_R_FILE_SUCCESS:
      return {
        ...state,
      };
    case CREATE_R_FILE_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case UPDATE_R_FILE_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case UPDATE_R_FILE_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_R_FILE_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case DELETE_R_FILE_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case DELETE_R_FILE_SUCCESS:
      return {
        ...state,
      };
    case DELETE_R_FILE_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case UPDATE_RESOURCES_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case UPDATE_RESOURCES_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_RESOURCES_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case BULK_GOAL_UPDATE_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case BULK_GOAL_UPDATE_SUCCESS:
      return {
        ...state,
      };
    case BULK_GOAL_UPDATE_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case UPADTE_GOAL_LABEL_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case UPADTE_GOAL_LABEL_SUCCESS:
      return {
        ...state,
      };
    case UPADTE_GOAL_LABEL_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case UPDATE_GOAL_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case UPDATE_GOAL_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_GOAL_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case DELETE_GOAL_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case DELETE_GOAL_SUCCESS:
      return {
        ...state,
      };
    case DELETE_GOAL_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case CREATE_REMINDER_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CREATE_REMINDER_SUCCESS:
      return {
        ...state,
      };
    case CREATE_REMINDER_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case CREATE_LABEL_AND_UNITS_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case CREATE_LABEL_AND_UNITS_SUCCESS:
      return {
        ...state,
      };
    case CREATE_LABEL_AND_UNITS_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case UPDATE_CUSTOMIZE_COLUMN_REQUEST:
      return { ...state, plan: { ...state.plan } };
    case UPDATE_CUSTOMIZE_COLUMN_FROZEN_REQUEST:
      return { ...state, plan: { ...state.plan } };
    case UPDATE_CUSTOMIZE_COLUMN_FROZEN_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_CUSTOMIZE_COLUMN_FROZEN_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    case UPDATE_CUSTOMIZE_COLUMN_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_CUSTOMIZE_COLUMN_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };

    case GET_CUSTOMIZE_COLUMN_REQUEST: {
      return {
        ...state,
        plan: { ...state.plan, loadingCustomizeColumn: true },
      };
    }
    case GET_CUSTOMIZE_COLUMN_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          customizeColumn: action.payload,
          loadingCustomizeColumn: false,
          success: true,
        },
      };
    case GET_CUSTOMIZE_COLUMN_ERROR:
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingCustomizeColumn: false,
          error: action.error,
        },
      };

    case GET_CUSTOMIZE_COLUMN_FROZEN_REQUEST:
      return {
        ...state,
        plan: { ...state.plan, loadingCustomizeColumnFrozen: true },
      };
    case GET_CUSTOMIZE_COLUMN_FROZEN_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          customizeColumnFrozen: action.payload,
          loadingCustomizeColumnFrozen: false,
          success: true,
        },
      };
    case GET_CUSTOMIZE_COLUMN_FROZEN_ERROR:
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingCustomizeColumnFrozen: false,
          error: action.error,
        },
      };

    case GET_GOAL_LIST_REQUEST:
      return {
        ...state,
        plan: {
          ...state.plan,
          loading: action?.payload?.is_loading ? true : false,
          LoadingGoals: action?.payload?.is_loading ? true : false,
        },
      };
    case GET_GOAL_LIST_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          allGoalList: action.isLoadMore
            ? [...state.plan.allGoalList, ...action.payload]
            : action.payload,
          loading: false,
          LoadingGoals: false,
          success: true,
        },
      };
    case GET_GOAL_LIST_ERROR:
      return {
        ...state,
        plan: {
          ...state.plan,
          loading: false,
          LoadingGoals: false,
          error: action.error,
        },
      };
    case GET_GOAL_LIST_BY_ID_REQUEST:
      return { ...state, plan: { ...state.plan, loading: true } };
    case GET_GOAL_LIST_BY_ID_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          selectedGoalList: action.payload,
          loading: false,
          success: true,
        },
      };
    case GET_GOAL_LIST_BY_ID_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };

    case CLEAR_SELECTED_GOAL_LIST:
      return {
        ...state,
        plan: {
          ...state.plan,
          selectedGoalList: null,
        },
      };

    case CLEAR_UPLOAD_FILE:
      return {
        ...state,
        plan: {
          ...state.plan,
          uploadFile: null,
        },
      };

    case UPLOAD_FILE_WITHOUT_PROJECTID_REQUEST: {
      return { ...state, plan: { ...state.plan, loadingUplaod: true } };
    }

    case UPLOAD_FILE_WITHOUT_PROJECTID_SUCCESS: {
      return {
        ...state,
        plan: {
          ...state.plan,
          uploadFile: action.payload,
          loadingUplaod: false,
        },
      };
    }
    case UPLOAD_FILE_WITHOUT_PROJECTID_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loadingUplaod: false, error: action.error },
      };
    }

    case CREATE_PROJECT_PLAN_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case CREATE_PROJECT_PLAN_SUCCESS: {
      return {
        ...state,
        plan: { ...state.plan, loading: false },
      };
    }
    case CREATE_PROJECT_PLAN_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }
    case UPDATE_USER_TUTORIAL_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case UPDATE_USER_TUTORIAL_SUCCESS: {
      return {
        ...state,
        plan: { ...state.plan, loading: false },
      };
    }
    case UPDATE_USER_TUTORIAL_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }

    case GET_PROJECT_PREFERENCES_REQUEST: {
      return {
        ...state,
        plan: { ...state.plan, loading: true },
      };
    }
    case GET_PROJECT_PREFERENCES_SUCCESS: {
      return {
        ...state,
        plan: {
          ...state.plan,
          planPreferences: action.payload,
          loading: false,
        },
      };
    }
    case GET_PROJECT_PREFERENCES_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }

    case CREATE_PROJECT_PREFERENCES_REQUEST: {
      return {
        ...state,
        plan: { ...state.plan, loadingUpdatePerferences: true },
      };
    }
    case CREATE_PROJECT_PREFERENCES_SUCCESS: {
      return {
        ...state,
        plan: { ...state.plan, loadingUpdatePerferences: false },
      };
    }
    case CREATE_PROJECT_PREFERENCES_ERROR: {
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingUpdatePerferences: false,
          error: action.error,
        },
      };
    }

    case UPDATE_PROJECT_PREFERENCES_REQUEST: {
      return {
        ...state,
        plan: { ...state.plan, loadingUpdatePerferences: true },
      };
    }
    case UPDATE_PROJECT_PREFERENCES_SUCCESS: {
      return {
        ...state,
        plan: { ...state.plan, loadingUpdatePerferences: false },
      };
    }
    case UPDATE_PROJECT_PREFERENCES_ERROR: {
      return {
        ...state,
        plan: {
          ...state.plan,
          loadingUpdatePerferences: false,
          error: action.error,
        },
      };
    }

    case UPDATE_PROJECT_MANUAL_STATUS_REQUEST: {
      return {
        ...state,
        plan: { ...state.plan, updateStatusLoading: true },
      };
    }
    case UPDATE_PROJECT_MANUAL_STATUS_SUCCESS: {
      return {
        ...state,
        plan: { ...state.plan, updateStatusLoading: false },
      };
    }
    case UPDATE_PROJECT_MANUAL_STATUS_ERROR: {
      return {
        ...state,
        plan: {
          ...state.plan,
          updateStatusLoading: false,
          error: action.error,
        },
      };
    }
    case POST_METRIC_REQUEST: {
      return {
        ...state,
        plan: { ...state.plan, loading: true },
      };
    }
    case POST_METRIC_SUCCESS: {
      return {
        ...state,
        plan: { ...state.plan, loading: false },
      };
    }
    case POST_METRIC_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }
    case ADD_BULK_CATEGORY_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case ADD_BULK_CATEGORY_SUCCESS: {
      return { ...state, plan: { ...state.plan, loading: false } };
    }
    case ADD_BULK_CATEGORY_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }
    case UPDATE_BULK_ACTION_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case UPDATE_BULK_ACTION_SUCCESS: {
      return { ...state, plan: { ...state.plan, loading: false } };
    }
    case UPDATE_BULK_ACTION_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }
    case WEIGHT_MODEL:
      return {
        ...state,
        plan: { ...state.plan, weightModel: action.payload },
      };

    case IS_CATEGORY_STATE_UNACTIVE: {
      const existingCategories = state.plan.isUnActiveCategories || [];
      const categoryIndex = existingCategories.findIndex(
        (cat) => cat.id === action.payload.id
      );

      let updatedCategories;
      if (categoryIndex !== -1) {
        updatedCategories = existingCategories.map((cat) =>
          cat.id === action.payload.id
            ? { ...cat, isUnActive: action.payload.isUnActive }
            : cat
        );
      } else {
        updatedCategories = [
          ...existingCategories,
          {
            id: action.payload.id,
            isUnActive: action.payload.isUnActive,
          },
        ];
      }

      return {
        ...state,
        plan: { ...state.plan, isUnActiveCategories: updatedCategories },
      };
    }

    case WIZARD_DATA:
      return {
        ...state,
        plan: { ...state.plan, wizardData: action.payload },
      };
    case SORT_DATA:
      return {
        ...state,
        plan: { ...state.plan, sortData: action.payload },
      };

    case UPDATE_CATEGORY_NAME_REQUEST: {
      return {
        ...state,
        plan: { ...state.plan, updateCategoryNameLoading: true },
      };
    }
    case UPDATE_CATEGORY_NAME_SUCCESS: {
      return {
        ...state,
        plan: { ...state.plan, updateCategoryNameLoading: false },
      };
    }
    case UPDATE_CATEGORY_NAME_ERROR: {
      return {
        ...state,
        plan: {
          ...state.plan,
          updateCategoryNameLoading: false,
          error: action.error,
        },
      };
    }

    case CREATE_PROJECT_WITH_WIZARD_REQUEST:
      return {
        ...state,
        plan: { ...state.plan, loading: true },
      };
    case CREATE_PROJECT_WITH_WIZARD_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          wizardData: action.payload,
          loading: false,
        },
      };
    case CREATE_PROJECT_WITH_WIZARD_ERROR:
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };

    case BULK_ARIA_PROJECT_PLAN_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case BULK_ARIA_PROJECT_PLAN_SUCCESS: {
      return { ...state, plan: { ...state.plan, loading: false } };
    }
    case BULK_ARIA_PROJECT_PLAN_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }

    case LOGOUT_SUCCESS:
      return {
        ...state,
        plan: {
          ...state.plan,
          allPlans: [],
          success: false,
          loading: false,
          error: null,
        },
      };
    case GET_PREDEFINED_METRICS_REQUEST: {
      return {
        ...state,
        plan: { ...state.plan, loading: true },
        predefinedMetrics: action?.payload,
      };
    }
    case GET_PREDEFINED_METRICS_SUCCESS: {
      return {
        ...state,
        plan: { ...state.plan, loading: false },
        predefinedMetrics: action?.payload,
      };
    }
    case GET_PREDEFINED_METRICS_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }
    case NOTIFICATION_SETTING_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case NOTIFICATION_SETTING_SUCCESS: {
      return { ...state, plan: { ...state.plan, loading: false } };
    }
    case NOTIFICATION_SETTING_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }
    case UPDATE_CATEGORY_STATE_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case UPDATE_CATEGORY_STATE_SUCCESS: {
      return { ...state, plan: { ...state.plan, loading: false } };
    }
    case UPDATE_CATEGORY_STATE_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }
    case GET_NOTIFICATION_SETTING_REQUEST: {
      return {
        ...state,
        plan: {
          ...state.plan,
          loading: true,
          notificationData: action.payload,
        },
      };
    }
    case GET_NOTIFICATION_SETTING_SUCCESS: {
      return {
        ...state,
        plan: {
          ...state.plan,
          loading: false,
          notificationData: action.payload,
        },
      };
    }
    case GET_NOTIFICATION_SETTING_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }
    case UPLOAD_CSV_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case UPLOAD_CSV_SUCCESS: {
      return {
        ...state,
        plan: {
          ...state.plan,
          ...state.plan,
          uploadCSVData: action.payload,
          loading: false,
          success: true,
        },
      };
    }
    case UPLOAD_CSV_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }
    case GET_ACTIVITY_LOG_REQUEST: {
      return { ...state, plan: { ...state.plan, activityLoading: true } };
    }
    case GET_ACTIVITY_LOG_SUCCESS: {
      return {
        ...state,
        plan: {
          ...state.plan,
          activityLoading: false,
          activityLog: action.payload,
        },
      };
    }
    case GET_ACTIVITY_LOG_ERROR: {
      return {
        ...state,
        plan: {
          ...state.plan,
          activityLoading: false,
          error: action.error,
        },
      };
    }
    case GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_REQUEST: {
      return {
        ...state,
        plan: {
          ...state.plan,
          commentOfSpecificActionItemLoading: true,
        },
      };
    }
    case GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_SUCCESS: {
      return {
        ...state,
        plan: {
          ...state.plan,
          commentOfSpecificActionItemLoading: false,
          commentOfSpecificActionItem: action.payload,
        },
      };
    }
    case GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_ERROR: {
      return {
        ...state,
        plan: {
          ...state.plan,
          commentOfSpecificActionItemLoading: false,
          error: action.error,
        },
      };
    }
    case CREATE_ACTION_ITEM_COMMENT_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case CREATE_ACTION_ITEM_COMMENT_SUCCESS: {
      return {
        ...state,
        plan: { ...state.plan, loading: false },
      };
    }
    case CREATE_ACTION_ITEM_COMMENT_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }

    case LIKE_COMMENT_REQUEST: {
      return { ...state, plan: { ...state.plan } };
    }
    case LIKE_COMMENT_SUCCESS: {
      return { ...state, plan: { ...state.plan } };
    }
    case LIKE_COMMENT_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }

    case UNLIKE_COMMENT_REQUEST: {
      return { ...state, plan: { ...state.plan } };
    }
    case UNLIKE_COMMENT_SUCCESS: {
      return { ...state, plan: { ...state.plan } };
    }
    case UNLIKE_COMMENT_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }

    case DELETE_COMMENT_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case DELETE_COMMENT_SUCCESS: {
      return { ...state, plan: { ...state.plan, loading: false } };
    }
    case DELETE_COMMENT_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }

    case REPLY_COMMENT_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case REPLY_COMMENT_SUCCESS: {
      return { ...state, plan: { ...state.plan, loading: false } };
    }
    case REPLY_COMMENT_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }

    case UPDATE_VIEW_TYPE_REQUEST: {
      return { ...state, plan: { ...state.plan, loading: true } };
    }
    case UPDATE_VIEW_TYPE_SUCCESS: {
      return { ...state, plan: { ...state.plan, loading: false } };
    }
    case UPDATE_VIEW_TYPE_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, loading: false, error: action.error },
      };
    }

    case VIEW_TYPE_LIST: {
      return {
        ...state,
        plan: { ...state.plan, viewTypeList: action.payload },
      };
    }

    case DUPLICATE_PLAN_REQUEST: {
      return { ...state, plan: { ...state.plan } };
    }
    case DUPLICATE_PLAN_SUCCESS: {
      return { ...state, plan: { ...state.plan } };
    }
    case DUPLICATE_PLAN_ERROR: {
      return {
        ...state,
        plan: { ...state.plan, error: action.error },
      };
    }

    case SET_CUSTOMIZE_COLUMNS_STATE: {
      return {
        ...state,
        plan: { ...state.plan, customizeColumnState: action.payload },
      };
    }

    default:
      return state;
  }
};
